import { render, staticRenderFns } from "./Professionnalisation.vue?vue&type=template&id=fb1b4726"
import script from "./Professionnalisation.vue?vue&type=script&lang=js"
export * from "./Professionnalisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports